import { Box, FormControl, Select, TextField, Typography, InputLabel, Stack, Button } from '@mui/material';
import React from 'react';

export const Location = () => {
    // const [selectedProvince, setSelectedProvince] = useState("");
    // const [selectedCity, setSelectedCity] = useState("");
    // const [selectedBarangays, setSelectedBarangays] = useState("");

    // const provinces = ["Nueva Ecija", "Pampanga", "Bulacan"];
    // const cities = {
    //     "Nueva Ecija": ["Cabanatuan", "San Jose"],
    //     "Pampanga": ["Angeles", "San Fernando"],
    //     "Bulacan": ["Malolos", "Meycauayan"]
    // };
    // const barangays = {
    //     "Cabanatuan": ["Bakod Bayan", "Bagong Sikat", "Bagong Buhay", "Aduas Sur", "Aduas Norte"],
    //     "San Jose": ["Canuto Ramos Poblacion", "Crisanto Sanchez Poblacion", "Culaylay", "Dizol", "Ferdinand E. Marcos Poblacion"],
    //     "Angeles": ["Agapito del Rosario", "Anunas", "Balibago", "Capaya", "Claro M. Recto"],
    //     "San Fernando": ["Alasas", "Baliti", "Bulaon", "Calulut", "Dela Paz Norte"],
    //     "Malolos": ["Anilao", "Atlag", "Bagna", "Bagong Bayan", "Balite"],
    //     "Meycauayan": ["Bagbaguin", "Bahay Pare", "Bancal", "Bayan-bayanan", "Banga"]
    // };
    // const handleProvinceChange = (event) => {
    //     setSelectedProvince(event.target.value);
    //     setSelectedCity("");
    // };
    // const handleCityChange = (event) => {
    //     setSelectedCity(event.target.value);
    // };
    // const handleBgrysChange = (event) => {
    //     setSelectedBarangays(event.target.value);
    // };

    return (
        <Box>
            {/* <Typography variant="body1" fontWeight={550} color="text.primary">Location</Typography>
            <FormControl fullWidth style={{ marginTop: 10 }}>
                <FormLabel sx={{fontSize: 14}}>Province</FormLabel>
                <Select value={selectedProvince} onChange={handleProvinceChange} size='small'>
                    <MenuItem value="">Choose Province</MenuItem>
                    {provinces.map((province) => (
                        <MenuItem key={province} value={province}>{province}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth style={{ marginTop: 10 }} disabled={!selectedProvince}>
                <FormLabel sx={{fontSize: 14}}>City</FormLabel>
                <Select value={selectedCity} onChange={handleCityChange} size='small'>
                    <MenuItem value="">{selectedProvince ? "Choose City" : "No City"}</MenuItem>
                    {selectedProvince && cities[selectedProvince]?.map((city) => (
                        <MenuItem key={city} value={city}>{city}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth style={{ marginTop: 10 }} disabled={!selectedCity}>
                <FormLabel sx={{fontSize: 14}}>Barangay</FormLabel>
                <Select 
                value={selectedBarangays}onChange={handleBgrysChange} size='small'>
                    <MenuItem value="">{selectedCity ? "Choose Barangay" : "No Barangay"}</MenuItem>
                    {selectedCity && barangays[selectedCity]?.map((barangay) => (
                        <MenuItem key={barangay} value={barangay}>{barangay}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Box mt={1}>
                <Typography variant="body1" color="text.secondary" sx={{fontSize: 14}}>Street Number</Typography>
                <TextField fullWidth size='small' />
            </Box> */}
            <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700" }}>Location<Typography component="span" color="error"> * </Typography></Typography>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Province<Typography component="span" color="error"> * </Typography></Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="province-label">Select Province</InputLabel>
                    <Select labelId="province-label" size='small' disabled label="Select Province" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>City<Typography component="span" color="error"> * </Typography></Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="city-label">Select City</InputLabel>
                    <Select labelId="city-label" size='small' disabled label="Select City" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Barangay<Typography component="span" color="error"> * </Typography></Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="barangay-label">Select Barangay</InputLabel>
                    <Select labelId="barangay-label" size='small' disabled label="Select Barangay" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Street Number</Typography>
                <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff"  }}/>
            </Box>
            <Box mt="1rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", }}>Indoor Facilities<Typography component="span" color="error"> * </Typography></Typography>
                <Stack alignItems="center">
                    <Button variant="contained" disabled> Add Indoor Facilities </Button>
                </Stack>
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", m: "1rem 0rem 0.5rem", }}>Outdoor Facilities<Typography component="span" color="error"> * </Typography></Typography>
                <Stack alignItems="center">
				    <Button variant="contained" disabled> Add Outdoor Facilities </Button>
                </Stack>
            </Box>
        </Box>
    );
};